import { render } from "./HotelBookingView.vue?vue&type=template&id=3a9f0aaf"
import script from "./HotelBookingView.vue?vue&type=script&lang=js"
export * from "./HotelBookingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__